<template>
  <div class="field-group field-group-full widget-postal-field-group">
    <label class="field-label-compact">Código Postal</label>
    <WidgetPostalCodeField
      :model-value="postalCodeDisplay"
      placeholder="Ej: 03810"
      size="large"
      @select="emit('select', $event)"
      @clear="emit('clear')"
      @invalidate="emit('invalidate')"
      @update:model-value="emit('update:postalCodeDisplay', $event)"
    />
  </div>
</template>

<script setup lang="ts">
import type { PostalCodeOption } from '@/composables/usePostalCode';
import WidgetPostalCodeField from '@/components/widget/WidgetPostalCodeField.vue';

defineProps<{ postalCodeDisplay: string }>();

const emit = defineEmits<{
  select: [item: PostalCodeOption];
  clear: [];
  invalidate: [];
  'update:postalCodeDisplay': [value: string];
}>();
</script>

<style scoped src="./fields.css"></style>
<style scoped>
.widget-postal-field-group {
  position: relative;
  z-index: 40;
  overflow: visible;
}
</style>
